import React from 'react'

export const ManageAccountNotImplemented = () => {
    return (
        <>
            <h3>Error!</h3>
            <p>
                I don't know how you got here, but this page is not implemented!
            </p>
        </>
    )
}
